import { render, staticRenderFns } from "./GraphDetail36.vue?vue&type=template&id=8736ab8a&scoped=true"
import script from "./GraphDetail36.vue?vue&type=script&lang=js"
export * from "./GraphDetail36.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8736ab8a",
  null
  
)

export default component.exports